
import { defineComponent, PropType } from 'vue'
import { iFilter } from '../../QBE'
import Dropdown from 'primevue/dropdown'
import QBEHavingDialogDescriptor from './QBEHavingDialogDescriptor.json'

export default defineComponent({
    name: 'qbe-filter-card',
    components: { Dropdown },
    props: { propHaving: { type: Object as PropType<iFilter> }, entities: { type: Array } },
    emits: ['removeHaving'],
    data() {
        return {
            QBEHavingDialogDescriptor,
            having: null as iFilter | null,
            targetValues: [
                {
                    label: this.$t('qbe.filters.targets.manual'),
                    value: ''
                },
                {
                    label: this.$t('qbe.filters.targets.entity'),
                    value: 'anotherEntity'
                }
            ]
        }
    },
    watch: {
        propHaving() {
            this.loadHaving()
        }
    },
    created() {
        this.loadHaving()
    },
    methods: {
        loadHaving() {
            this.having = this.propHaving as iFilter
        },
        onHavingTypeChange() {
            if (this.having) {
                this.having.rightOperandDescription = ''
                this.having.rightOperandLongDescription = ''
                this.having.rightOperandAggregator = ''
                this.having.rightOperandType = this.having.rightType === 'anotherEntity' ? 'Field Content' : 'Static Content'
            }
        },
        onManualValueChange() {
            if (this.having) {
                this.having.rightOperandValue = [this.having.rightOperandDescription]
            }
        },
        onEntityTypeChanged() {
            if (this.having) {
                if (this.having.rightOperandType === 'Field Content' && this.entities) {
                    let rightOperand = null as any
                    const index = this.entities.findIndex((entity: any) => this.having?.rightOperandDescription === entity.id)
                    if (index !== -1) rightOperand = this.entities[index]
                    this.having.rightOperandAggregator = rightOperand.funct
                }

                this.having.rightOperandValue = [this.having.rightOperandDescription]
                this.having.rightOperandLongDescription = this.having.rightOperandDescription
            }
        }
    }
})
